/**
 * Error Logger Utility
 * Centralized error logging for the application
 * Can be extended to integrate with error reporting services (Sentry, LogRocket, etc.)
 */

/**
 * Log an error to the console and optionally to an error reporting service
 * @param {Error} error - The error object
 * @param {Object} errorInfo - Additional error information (component stack, etc.)
 * @param {Object} context - Additional context about where the error occurred
 */
export const logError = (error, errorInfo = null, context = {}) => {
  const errorData = {
    message: error.message,
    stack: error.stack,
    errorInfo,
    context,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href,
  };

  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.error('Error logged:', errorData);
  }

  // TODO: Integrate with error reporting service
  // Example: Sentry.captureException(error, { extra: errorData });
  // Example: logToService(errorData);
};

/**
 * Log a warning
 * @param {string} message - Warning message
 * @param {Object} context - Additional context
 */
export const logWarning = (message, context = {}) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn('Warning:', message, context);
  }
  
  // TODO: Integrate with error reporting service for warnings
};

/**
 * Log an info message
 * @param {string} message - Info message
 * @param {Object} context - Additional context
 */
export const logInfo = (message, context = {}) => {
  if (process.env.NODE_ENV === 'development') {
    console.info('Info:', message, context);
  }
};

